import { overView } from "../client";

export const getAllOverviewCount = (params) => {
    const payload = {
        businessId: params?.businessId,
        startDate: params?.startDate,
        endDate: params?.endDate,
    };
    return overView.post("/overview", payload);
};

export const getDashboardRightCard = (params) => {
    const payload = {
        businessId: params?.businessId,
        startDate: params?.startDate,
        endDate: params?.endDate,
    };
    return overView.post("/sentimentReport", payload);
};

export const getAllOverviewReport = (params) => {
    const payload = {
        businessId: params?.businessId,
        startDate: params?.startDate,
        endDate: params?.endDate,
    };
    return overView.post("/conversation/export", payload);
};

export const getBusinessName = () => {
    return overView.post("/get/business");
};

export const getOverviewData = (params) => {
    const payload = { ...params };
    return overView.post("/overview/day", payload);
};
export const getTheBussinessByClientBased = (params) => {
    const payload = {
        clientId: params?.clientId,
    };

    return overView.post("/get/businessByClient", payload);
};
export const getName = (params) => {
    const payload = {
        businessId: params?.businessId,
    };
    return overView.post("/name/businessId", payload);
};
